// your own connected Google account (Settings › Account). Connecting is a browser navigation to
// GOOGLE_CONNECT_URL (off to Google and back to /settings?google=connected, or ?googleError=…).
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { MyGoogleAccount } from '@technohull/shared';
import { api } from '../lib/api.js';
import { COOP_QUIET } from '../collab/collabHooks.js';

export const GOOGLE_CONNECT_URL = '/api/me/google/connect';

export function useMyGoogle() {
  return useQuery({
    queryKey: ['me', 'google'],
    queryFn: () => api.get<MyGoogleAccount>('/api/me/google'),
    staleTime: 60_000,
  });
}

export function useMyGooglePrimary() {
  const qc = useQueryClient();
  return useMutation({
    meta: COOP_QUIET,
    mutationFn: (primary: boolean) => api.post('/api/me/google/primary', { primary }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['me', 'google'] }),
  });
}

export function useMyGoogleDisconnect() {
  const qc = useQueryClient();
  return useMutation({
    meta: COOP_QUIET,
    mutationFn: () => api.post('/api/me/google/disconnect', {}),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['me', 'google'] }),
  });
}
